<template>
  <div>
    <template v-if="pms">
      <user-management />
    </template>
    <no-pms v-else></no-pms>
  </div>
</template>

<script>
import mixin from "./components/Mixins";
import components from "./components";
import NoPms from "@/components/NoPms.vue";
export default {
  mixins: [components, mixin],

  components: {
    NoPms 
  },

  created() {
    let pms = JSON.parse(window.sessionStorage.getItem("binyi_cms_pms"));
    this.pms = pms["60000"].check;
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/PartII/UserManagement/index.vue